/**
 * `/cases/:id` — one case.
 *
 * One `RouteObject`, so the file is `detail.route.tsx` (singular). It must be
 * registered AFTER `cases/new`: both are one segment past `cases`, and a
 * dynamic segment declared first would swallow the literal one.
 *
 * The param is read inside the page rather than validated in a loader — no
 * `loader` in this repo performs a data read, and a bad id is answered by the
 * backend's own `404 SUPPORT_CASE_NOT_FOUND`, which is the same response an
 * ownership miss gets.
 */
import type { RouteObject } from 'react-router-dom';

export const caseDetailRoute: RouteObject = {
  path: 'cases/:id',
  lazy: async () => {
    const { CaseDetailPage } = await import('./CaseDetailPage');
    return { Component: CaseDetailPage };
  },
};
